<template>
  <div id="page-top-company-view">
    

    <memlist-modal size="xl" ref="grant-wizard">
      <GrantWizard
        v-if="selected_todo_id"
        :ref_todo_id="selected_todo_id"
      />
    </memlist-modal>

    <m-row class="mt-4">
      <m-col cols="4">

        <memlist-select-input2
          v-model="selected_status"
          :items="status_options"
          :title="'Status'"
          layout="vertical"
          size="sm"
          validation_type="TEXT"
        />
        
      </m-col>

    </m-row>

    <m-row>
      <m-col cols="6">
        <memlist-text-input 
          v-model="search"
          type="search"
          style="max-width: 380px;"
          placeholder="Sök förening"
        />
        
      </m-col>
      <m-col cols="6">
        <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">

          <memlist-pagination 
            :per_page="per_page" 
            :total_rows="total_rows" 
            @page-changed="current_page = $event"
            @per-page-changed="per_page = $event"
            aria-controls="member-registrations-table"
          />

        </div>
      </m-col>
    </m-row>

    <m-row class="mt-4">
      <m-col lg="12">

        <memlist-ajax-table
          ref="grant-table"
          :fields="grant_headers"
          :items="ajax_pagination"
          :per_page="per_page"
          :current_page="current_page"
          :tbody-tr-class="row_class"
          @sort-changed="on_sort_changed"
        >
          <template #cell(created_at)="{ item }">
            <span>{{ formatDate(item.created_at) }}</span>
          </template>
          <template #cell(updated_at)="{ item }">
            <span>{{ formatDate(item.updated_at) }}</span>
          </template>


          <template #cell(status)="{ item }">

            <memlist-badge :status="calc_status_variant(item.status)">
              {{ calc_status_text(item.status) }}
            </memlist-badge>
            
          </template>

          <template #cell(actions)="row">
            <div class="justify-content-end d-flex">
              <memlist-table-button class="mr-2" @click="selectGrantClicked(row.item.todo_id)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')" />
              <memlist-table-button class="mr-2" @click="edit_receipts(row.item)" svg="/assets/svg/file-invoice-dollar-solid.svg" :tooltip="$t('TODO.EDIT_RECEIPTS')" />
          
              <memlist-table-button class="mr-2" @click="downloadGrantSummary(row.item.todo_id)" svg="/assets/svg/download-solid.svg" :tooltip="$t('FILE.DOWNLOAD')" />
              <memlist-table-button class="mr-2" @click="deleteGrantClicked(row.item.todo_id)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />
            </div>
          </template>

          
        </memlist-ajax-table>
      </m-col>
    </m-row>


  </div>
</template>


<script>
import axios from 'axios';
import dayjs from 'dayjs';

import { mapGetters } from 'vuex';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

import Multiselect from '@vueform/multiselect/dist/multiselect.vue2.js';
import GrantWizard from '@/view/pages/ml/grantwizard/GrantWizard.vue';

export default {
  name: 'GrantTopCompanyTable',
  components: {
    GrantWizard,
    Multiselect,
  },
  mixins: [ toasts ],
  props: [],
  emits: ['onStatusChanged', 'selectGrantClicked', 'showTodoTaskFilesClicked', 'showTodoTaskCommentsClicked', 'selectTodoTaskClicked', 'deleteTodoTaskClicked', 'updateTodoTaskStatus'],
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId']),
    
  },
  mounted() {
    for (const s of this.status_options) {
      this.status_options_select.push({ label: s.text, code: s.value });
    }
  },
  data() {
    return {
      order_by_dir: 'desc',
      order_by_col: 'todo_id',
      debounce_timer: null,
      selected_todo_id: null,
      filters: {},
      status_options_select: [],
      status_options: [
        { value: 'WAIT', text: 'Handläggs' },
        { value: 'ACC', text: 'Godkänt' },
        { value: 'REJ', text: 'Nekat' },
        { value: 'NOT', text: 'Komplettera' },
        { value: 'DONE', text: 'Klar' },
        { value: 'CLOSE', text: 'Avslutat' },
      ],
      search: null,
      selected_status: null,
      rowsPerPage: [100, 500, 1000, -1],
      current_page: 1,
      per_page: 100,
      total_rows: 0,
      singleExpand: false,
      activeExpanded: [],
      closedExpanded: [],
      editing: false,
      creating: false,

      statusName: {
        DRAFT: 'Utkast',
        INVALID: 'Ej giltig',
        WAIT: 'Handläggs',
        NOT: 'Komplettera',
        DONE: 'Klar',
        CN: 'Bekräftat',
        DEL: 'Raderat',
        ACC: 'Accepterat',
        REJ: 'Avslaget',
        BAC: 'Backlog',
        FUT: 'Framtida',
        CLOSE: 'Avslutat'
      },
      headerProps: {
        sortByText: 'Sortera'
      },
      grant_headers: [
        { 
          label: 'Ansökningsnamn', 
          key: 'name', 
          sortable: true,
          tdClass: 'td-short4',
          thClass: 'td-short4',
          filterable: false, 
        },
        { 
          label: 'Datum', 
          key: 'created_at', 
          tdClass: 'td-short3',
          thClass: 'td-short3',
          sortable: true, 
          filterable: false,
          formatter: (_, __, item) => {
            return dayjs(item.created_at).format('YYYY-MM-DD');
          } 
        },
        { 
          label: 'Uppdaterat', 
          key: 'updated_at', 
          tdClass: 'td-short3',
          thClass: 'td-short3',
          sortable: true,
          filterable: false, 
          formatter: (_, __, item) => {
            return dayjs(item.updated_at).format('YYYY-MM-DD');
          } 
        },
        {
          label: 'Förening',
          tdClass: 'td-short4',
          thClass: 'td-short4',
          align: 'start',
          sortable: true,
          key: 'creator_company',
          filterable: true,
          formatter: (_, __, item) => {
            return item.creator_company ? item.creator_company.name : '-';
          }
        },
        { 
          label: '# Filer', 
          key: 'num_files',
          tdClass: 'td-short2',
          thClass: 'td-short2',
          filterable: false, 
        },
        {
          label: '# Chat',
          tdClass: 'td-short2',
          thClass: 'td-short2',
          key: 'num_comments', 
          filterable: false,
        },
        { 
          label: 'Status', 
          key: 'status',
          tdClass: 'td-short4',
          thClass: 'td-short4',
          sortable: true,
          filterable: true, 
        },
        { 
          label: this.$t('COMMON.ACTIONS'), 
          key: 'actions',
          tdClass: 'td-short4',
          thClass: 'td-short4',
          filterable: false 
        },
      ],
    };
  },
  watch: {
    selected_status(newValue) {
      this.$refs['grant-table'].refresh();
      
    },

    search() {

      clearTimeout(this.debounce_timer);

      this.debounce_timer = setTimeout(async () => {
        this.$refs['grant-table'].refresh();
      }, 500); 
      
    },

  },
  methods: {

    refresh() {
      this.$refs['grant-table'].refresh();
    },

    on_sort_changed(sortChanged) {

      if (sortChanged.sortBy === '') {
        this.order_by_col = sortChanged.sortBy;
      }
      else {
        this.order_by_col = sortChanged.sortBy;
        this.order_by_dir = sortChanged.sortDesc ? 'desc' : 'asc';
      }
    },

    ajax_pagination: function(ctx, callback) {
      const vm = this;

      let params = {
        pageNo: ctx.current_page,
        pageSize: ctx.per_page,
        flag: 0,
        po: vm.searchOrderNumber,
        styNum: vm.searchStyleNumber
      };

      this.load_pagination(callback);

      return null;
    },

    get_search_param() {
      if (this.search) {
        return `&search=${this.search}`;
      }

      return '';
    },

    get_status_param() {
      if (this.selected_status) {
        return `&status=${this.selected_status}`;
      }

      return '';
    },


    async load_pagination(callback) {

      try {
        const res = await axios.get(`/todo?type=GRANT&company_id=${this.currentCompanyId}${this.get_search_param()}&order_by_col=${this.order_by_col}&dir=${this.order_by_dir}&page=${this.current_page}&limit=${this.per_page}${this.get_status_param()}`);

        if (res.status === 200) {
          this.total_rows = res.data.count;
          callback(res.data.todos || []);
        }
      }
      catch (err) {
        console.error('pagination error', err);
      }
    },

    edit_receipts(item) {
      this.selected_todo_id = item.todo_id;
      this.$nextTick(()=>{
        this.$refs['grant-wizard'].show();
      });
    },
    calc_status_text(status) {
      return this.$t('TODO.STATUSES.' + status);
    },
    calc_status_variant(status) {
      switch (status) {
        case 'DRAFT':
          return 'unpublished';
        
        case 'NOT':
        case 'DONE':
        case 'CN':
        case 'ACC':
        case 'REJ':
        case 'CN':
          return 'primary';

        case 'REJ':
        case 'CLOSE':
        case 'INVALID':
          return 'danger';
      }

      return 'primary';
    },
    toggle_details(row) {
      console.log(row);
    },
    row_class(item) {
      switch (item.status) {
        case 'WAIT': return 'table-primary';
        case 'ACC': return 'table-success';
        case 'REJ': return 'table-danger';
        case 'NOT': return 'table-warning';
        case 'DONE': return 'table-secondary';
        case 'CLOSE': return 'table-info';
        default: return null;
      }
    },
    async deleteGrantClicked(id) {
      const res = await axios.delete(`/todo/${id}`);

      if (res.status === 204) {
        this.$emit('deleted', id);
        this.$refs['grant-table'].refresh();
      }
    },
    async downloadGrantSummary(todo_id) {
      try {
        const res = await axios.post(`/todo/grantsummary/${todo_id}`, {});
        if (res.status === 201) {
          downloadWithAxios(get_base_url() + `/dlfile/${res.data.file.linkstr}`, res.data.file.name);
        }
      } catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.AN_ERROR_OCCURED'));
      }
    },

    formatDate(dt) {
      return dayjs(dt).format('YYYY-MM-DD');
    },
    custom_filter(row, filter) {
      const [search_query, selected_status] = filter;
      // Filter by search
      const matches_search = !search_query || row.creator_company?.name?.toLowerCase().includes(search_query?.toLowerCase());
      // Filter by status
      const matches_status = !selected_status || row.status === selected_status;

      return matches_search && matches_status;
    },
    onStatusChanged(todo_id, status) {
      this.$emit('onStatusChanged', todo_id, status);
    },
    selectGrantClicked(todo_id) {
      this.$emit('selectGrantClicked', todo_id);
    },

    showTodoTaskFilesClicked(todo_task_id) {
      this.$emit('showTodoTaskFilesClicked', todo_task_id);
    },
    showTodoTaskCommentsClicked(todo_task_id) {
      this.$emit('showTodoTaskCommentsClicked', todo_task_id);
    },
    selectTodoTaskClicked(todo_task_id) {
      this.$emit('selectTodoTaskClicked', todo_task_id);
    },
    deleteTodoTaskClicked(todo_task_id) {
      this.$emit('deleteTodoTaskClicked', todo_task_id);
    },
    updateTodoTaskStatus(todo_task_id, status, todo_task){
      this.$emit('updateTodoTaskStatus', todo_task_id, status, todo_task);
    },

    scrollToClassName(classname) {

      this.$nextTick(() => {
        const el = this.$el.getElementsByClassName(classname)[0];

        if (el) {
          const yOffset = -70;
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });

    },

  }
};
</script>

<style scoped lang="scss">
  
  

</style>
